module.exports = __webpack_public_path__ + "img/ic-engage.9c1a1ed.gif";